import { AxiosError } from 'axios'
import type { RouteLocationNormalized } from 'vue-router'

import { useSnackbar } from '~/portal/composables'
import { ResponseStatuses } from '~/quality-management/api/types'
import { useAuthStore } from '~/quality-management/stores/authStore/useAuthStore'
import {
	useEmployeeStore
} from '~/quality-management/stores/employeeStore/useEmployeeStore'
import { useUserStore } from '~/quality-management/stores/userStore/useUserStore'

export const authGuard = async (
	_to: RouteLocationNormalized,
	_from: RouteLocationNormalized
) => {
	const authStore = useAuthStore()
	try {
		if (!authStore.token) {
			await authStore.getAccessToken()
			await userGuard()
		}
	} catch (error) {
		console.error('Failed to fetch token:', error)
		return '/login'
	}
}

export const employeeGuard = async (
	to: RouteLocationNormalized,
	_from: RouteLocationNormalized
) => {
	const employeeStore = useEmployeeStore()
	const userId = Number(to.params.employeeId)

	try {
		const employee = await employeeStore.fetchEmployee(userId)

		if (!employee) {
			return '/quality-management/not-found'
		}
		if (employee instanceof AxiosError && employee.response?.status === ResponseStatuses.Forbidden) {
			return '/quality-management/no-access'
		}
	} catch (error) {
		const { showSnackbar } = useSnackbar()
		showSnackbar('Etwas ist schiefgelaufen', 'cp-base-red')

		return '/quality-management'
	}
}

export const userGuard = async () => {
	const userStore = useUserStore()
	await userStore.getUserData()
}
